export default "__VITE_ASSET__6ce94ab3__"